import { type SellScreenActionTypes } from "../../Actions/SellScreen/SellScreenActions";
import {
    ADD_INTEGRATED_PRODUCT_TO_SALE,
    SALE_CLEAR,
    SALE_SET_CURRENTLY_DISCOUNTING,
    SALE_SET_LIVE_PROFIT,
} from "../../Actions/SellScreen/SellScreenConstants";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";
import { getOption } from "../../Utilities/Platform/Options/Options";

export interface MiscellaneousState {
    liveProfit: boolean;
    addingIntegratedProduct: boolean;
    currentlyDiscounting: string | null;
}

function SellScreenMiscellaneousReducer(
    state: MiscellaneousState | undefined,
    action: ShopfrontActions<SellScreenActionTypes>
): MiscellaneousState {
    if(typeof state === "undefined") {
        return {
            liveProfit             : getOption("live_profit"),
            addingIntegratedProduct: false,
            currentlyDiscounting   : null,
        };
    }

    switch(action.type) {
        case SALE_SET_LIVE_PROFIT:
            return {
                ...state,
                liveProfit: action.liveProfit,
            };
        case ADD_INTEGRATED_PRODUCT_TO_SALE:
            return {
                ...state,
                addingIntegratedProduct: action.enabled,
            };
        case SALE_SET_CURRENTLY_DISCOUNTING:
            return {
                ...state,
                currentlyDiscounting: action.item,
            };
        case SALE_CLEAR:
            return {
                ...state,
                currentlyDiscounting: null,
            };
    }

    return state;
}

export default SellScreenMiscellaneousReducer;
